<div class="mobile-lang-menu" [class.active]="showDropdown" (click)="toggleDropdown()">
  <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path>
  </svg>
  <span>{{ getCurrentLanguage()?.name }}</span>
  <svg 
    *ngIf="!showDropdown"
    width="16" 
    height="16" 
    fill="none" 
    stroke="currentColor" 
    viewBox="0 0 24 24"
    class="chevron-down">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
  </svg>
  <svg 
    *ngIf="showDropdown"
    width="16" 
    height="16" 
    fill="none" 
    stroke="currentColor" 
    viewBox="0 0 24 24"
    class="chevron-up">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
  </svg>
</div>

<div class="mobile-lang-submenu" *ngIf="showDropdown">
  <a 
    *ngFor="let lang of languages" 
    class="lang-item"
    [class.active]="lang.code === currentLanguage"
    href="javascript:void(0)"
    (click)="selectLanguage(lang.code)">
    <span class="flag-icon">{{ lang.flag }}</span>
    <span class="language-name">{{ lang.name }}</span>
  </a>
</div>

